window.benji = window.benji || {};

class Utils {
    static moneyFormat = "${{amount}}";

    static selectors = {
        addToCart: "[data-add-to-cart]",
        addToCartText: "[data-add-to-cart-text]",
        comparePrice: "[data-compare-price]",
        comparePriceText: "[data-compare-text]",
        originalSelectorId: "[data-product-select]",
        priceWrapper: "[data-price-wrapper]",
        productFeaturedImage: "[data-product-featured-image]",
        productJson: "[data-product-json]",
        productPrice: "[data-product-price]",
        productThumbs: "[data-product-single-thumbnail]",
        singleOptionSelector: "[data-single-option-selector]",
        recoverPasswordForm: "#RecoverPassword",
        hideRecoverPasswordLink: "#HideRecoverPasswordLink",
    };

    static removeProtocol(path) {
        return path.replace(/http(s)?:/, "");
    }

    static getSizedImageUrl(src, size) {
        if (size === null) {
            return src;
        }

        if (size === "master") {
            return Utils.removeProtocol(src);
        }

        const match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

        if (match) {
            const prefix = src.split(match[0]);
            const suffix = match[0];

            return Utils.removeProtocol(prefix[0] + "_" + size + suffix);
        } else {
            return null;
        }
    }

    static findInstance(array, key, value) {
        for (let i = 0; i < array.length; i++) {
            if (array[i][key] === value) {
                return array[i];
            }
        }
    }

    static removeInstance(array, key, value) {
        let i = array.length;
        while (i--) {
            if (array[i][key] === value) {
                array.splice(i, 1);
                break;
            }
        }

        return array;
    }

    static compact(array) {
        let index = -1;
        const length = array == null ? 0 : array.length;
        let resIndex = 0;
        const result = [];

        while (++index < length) {
            const value = array[index];
            if (value) {
                result[resIndex++] = value;
            }
        }
        return result;
    }

    static defaultTo(value, defaultValue) {
        return value == null || value !== value ? defaultValue : value;
    }

    static formatMoney(cents, format) {
        if (typeof cents === "string") {
            cents = cents.replace(".", "");
        }
        var value = "";
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = format || Utils.moneyFormat;

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = Utils.defaultTo(precision, 2);
            thousands = Utils.defaultTo(thousands, ",");
            decimal = Utils.defaultTo(decimal, ".");

            if (isNaN(number) || number == null) {
                return 0;
            }

            number = (number / 100.0).toFixed(precision);

            var parts = number.split(".");
            var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
            var centsAmount = parts[1] ? decimal + parts[1] : "";

            return dollarsAmount + centsAmount;
        }

        switch (formatString.match(placeholderRegex)[1]) {
            case "amount":
                value = formatWithDelimiters(cents, 2);
                break;
            case "amount_no_decimals":
                value = formatWithDelimiters(cents, 0);
                break;
            case "amount_with_space_separator":
                value = formatWithDelimiters(cents, 2, " ", ".");
                break;
            case "amount_no_decimals_with_comma_separator":
                value = formatWithDelimiters(cents, 0, ",", ".");
                break;
            case "amount_no_decimals_with_space_separator":
                value = formatWithDelimiters(cents, 0, " ");
                break;
        }

        return formatString.replace(placeholderRegex, value);
    }
}

class Sections {
    constructor() {
        this.constructors = {};
        this.instances = [];

        $(document)
            .on("shopify:section:load", this._onSectionLoad.bind(this))
            .on("shopify:section:unload", this._onSectionUnload.bind(this))
            .on("shopify:section:select", this._onSelect.bind(this))
            .on("shopify:section:deselect", this._onDeselect.bind(this))
            .on("shopify:section:reorder", this._onReorder.bind(this))
            .on("shopify:block:select", this._onBlockSelect.bind(this))
            .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
    }

    _createInstance(container, constructor) {
        const $container = $(container);
        const id = $container.attr("data-section-id");
        const type = $container.attr("data-section-type");

        constructor = constructor || this.constructors[type];

        if (typeof constructor === "undefined") {
            return;
        }

        const instance = $.extend(new constructor(container), {
            id: id,
            type: type,
            container: container,
        });

        this.instances.push(instance);
    }

    _onSectionLoad(evt) {
        const container = $("[data-section-id]", evt.target)[0];
        if (container) {
            this._createInstance(container);
        }
    }

    _onSectionUnload(evt) {
        const instance = Utils.findInstance(this.instances, "id", evt.detail.sectionId);

        if (!instance) {
            return;
        }

        if (typeof instance.onUnload === "function") {
            instance.onUnload(evt);
        }

        this.instances = Utils.removeInstance(this.instances, "id", evt.detail.sectionId);
    }

    _onSelect(evt) {
        const instance = Utils.findInstance(this.instances, "id", evt.detail.sectionId);

        if (instance && typeof instance.onSelect === "function") {
            instance.onSelect(evt);
        }
    }

    _onDeselect(evt) {
        const instance = Utils.findInstance(this.instances, "id", evt.detail.sectionId);

        if (instance && typeof instance.onDeselect === "function") {
            instance.onDeselect(evt);
        }
    }

    _onReorder(evt) {
        const instance = Utils.findInstance(this.instances, "id", evt.detail.sectionId);

        if (instance && typeof instance.onReorder === "function") {
            instance.onReorder(evt);
        }
    }

    _onBlockSelect(evt) {
        const instance = Utils.findInstance(this.instances, "id", evt.detail.sectionId);

        if (instance && typeof instance.onBlockSelect === "function") {
            instance.onBlockSelect(evt);
        }
    }

    _onBlockDeselect(evt) {
        const instance = Utils.findInstance(this.instances, "id", evt.detail.sectionId);

        if (instance && typeof instance.onBlockDeselect === "function") {
            instance.onBlockDeselect(evt);
        }
    }

    register(type, constructor) {
        this.constructors[type] = constructor;

        $(`[data-section-type=${type}]`).each((index, container) => {
            this._createInstance(container, constructor);
        });
    }
}

class Product {
    constructor(container) {
        this.$container = $(container);

        this.namespace = ".product";

        // Stop parsing if we don't have the product json script tag when loading
        // section in the Theme Editor
        if (!$(Utils.selectors.productJson, this.$container).html()) {
            return;
        }

        this.productSingleObject = JSON.parse($(Utils.selectors.productJson, this.$container).html());

        const urlParams = new URLSearchParams(window.location.search);
        const variantId = urlParams.get("variant");

        // If there's a variant ID in the URL, find the variant and update the price
        if (variantId) {
            const variant = this.productSingleObject.variants.find((v) => v.id.toString() === variantId);
            if (variant) {
                this.updateProductPrices({ variant: variant });
            }
        }

        const options = {
            $container: this.$container,
            enableHistoryState: this.$container.data("enable-history-state") || false,
            singleOptionSelector: Utils.selectors.singleOptionSelector,
            originalSelectorId: Utils.selectors.originalSelectorId,
            product: this.productSingleObject,
        };

        this.settings = {};
        this.variants = new Variants(options);
        this.$featuredImage = $(Utils.selectors.productFeaturedImage, this.$container);

        this.swatches = new Swatches(this.variants.currentVariant.option1);

        this.$container.on("variantChange" + this.namespace, this.updateAddToCartState.bind(this));

        this.$container.on("variantPriceChange" + this.namespace, this.updateProductPrices.bind(this));

        if (this.$featuredImage.length > 0) {
            const match = this.$featuredImage.attr("src")?.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
            if (match) {
                this.settings.imageSize = match[1];
            }

            this.$container.on("variantImageChange" + this.namespace, this.updateProductImage.bind(this));
        }

        const variantObject = {
            variant: this.variants.currentVariant,
        };

        this.updateProductImage(variantObject);
    }

    updateAddToCartState(evt) {
        const variant = evt.variant;

        if (variant) {
            $(Utils.selectors.priceWrapper, this.$container).removeClass("hide");
        } else {
            $(Utils.selectors.addToCart, this.$container).prop("disabled", true);
            $(Utils.selectors.addToCartText, this.$container).html("UNAVAILABLE");
            $(Utils.selectors.priceWrapper, this.$container).addClass("hide");
            return;
        }

        if (variant.available) {
            $(Utils.selectors.addToCart, this.$container).prop("disabled", false);
            $(Utils.selectors.addToCartText, this.$container).html("ADD TO CART");
        } else {
            $(Utils.selectors.addToCart, this.$container).prop("disabled", true);
            $(Utils.selectors.addToCartText, this.$container).html("SOLD OUT");
        }
    }

    updateProductPrices(evt) {
        const variant = evt.variant;

        const $comparePrice = $(Utils.selectors.comparePrice, this.$container);
        const $compareEls = $comparePrice.add(Utils.selectors.comparePriceText, this.$container);
        const $productPrice = $(Utils.selectors.productPrice, this.$container);

        const formattedPrice = "$" + Utils.formatMoney(variant.price, "{{amount_no_decimals}}") + " " + Shopify.currency.active;
        $(Utils.selectors.productPrice, this.$container).text(formattedPrice);
        this.$container.find("sale-price").text(formattedPrice);

        const sale_price = variant.price;
        //  const sale_price = variant.price * 0.85;

        $(this.container)
            .find(".sale-price")
            .html(Utils.formatMoney(sale_price, Utils.moneyFormat) + " " + Shopify.currency.active)
            .attr("data-sale-price", sale_price);

        if (variant.compare_at_price > variant.price) {
            $comparePrice.html(Utils.formatMoney(variant.compare_at_price, Utils.moneyFormat));
            $compareEls.removeClass("hide");
        } else {
            $comparePrice.html("");
            $compareEls.addClass("hide");
        }
    }

    updateProductImage(evt) {
        const variant = evt.variant;
        const sizedImgUrl = Utils.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
        const sizedImgUrlFancybox = Utils.getSizedImageUrl(variant.featured_image.src, "2000x");

        this.$featuredImage.attr("src", sizedImgUrl);
        this.$featuredImage.parent(".product-gallery__link").attr("href", sizedImgUrlFancybox);

        const color = variant.featured_image ? variant.featured_image.alt : null;
        const productID = variant.featured_image ? variant.featured_image.product_id : null;

        if (color) {
            //========= Filter slider
            $(`#product-slider-${productID}`).slick("slickUnfilter");
            $(`#product-slider-${productID}`).slick("slickFilter", function () {
                return $(`[data-color="${color}"]`, this).length === 1;
            });

            // scroll to the first slide
            $(`#product-slider-${productID}`).slick("slickGoTo", 0, true);

            // Filter Fancybox images
            $(`.product__images-slider [data-fancybox="${productID}"]`).attr("data-fancybox", "");
            const fancyboxElements = $(`#product-slider-${productID} [data-color="${color}"]`);
            if ($(`#product-slider-${productID}`).hasClass("product-slider--bundle")) {
                fancyboxElements.attr("data-fancybox", productID);
                $(".video-container").removeAttr("data-fancybox");
            } else {
                fancyboxElements.slice(0, fancyboxElements.length / 2).attr("data-fancybox", productID);
                $(".video-container").removeAttr("data-fancybox");
            }
            $(`#product-slider-${productID} .slick-dots`).css("opacity", "1");

            // Filter grid
            $(`#product-grid-${productID} .product-gallery__link`).hide();
            const imagesToShow = $(`#product-grid-${productID} .product-gallery__link`).filter(function () {
                return $(this).data("color") == color;
            });
            imagesToShow.show();

            // Filter Fancybox images
            $(`.product__images-grid [data-fancybox="${productID}"]`).attr("data-fancybox", "");
            const fancyboxElementsGrid = $(`#product-grid-${productID} [data-color="${color}"]`);
            fancyboxElementsGrid.slice(0, fancyboxElementsGrid.length / 2).attr("data-fancybox", productID);
            $(".video-container").removeAttr("data-fancybox");

            if (window.matchMedia("(max-width: 768px)").matches) {
                $(`#shopify-section-product .product__images-grid [data-fancybox="${productID}"]`).attr("data-fancybox", "");
            } else {
                $(`#shopify-section-product .product__images-slider [data-fancybox="${productID}"]`).attr("data-fancybox", "");
            }
        } else {
        }
    }

    onUnload() {
        this.$container.off(this.namespace);
    }
}

class Variants {
    constructor(options) {
        this.$container = options.$container;
        this.product = options.product;
        this.singleOptionSelector = options.singleOptionSelector;
        this.originalSelectorId = options.originalSelectorId;
        this.enableHistoryState = options.enableHistoryState;
        this.currentVariant = this._getVariantFromOptions();

        this._onSelectChange = this._onSelectChange.bind(this);
        $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange);
    }

    _getCurrentOptions() {
        const currentOptions = $.map($(this.singleOptionSelector, this.$container), (element) => {
            const $element = $(element);
            const type = $element.attr("type");
            const currentOption = {};

            if (type === "radio" || type === "checkbox") {
                if ($element[0].checked) {
                    currentOption.value = $element.val();
                    currentOption.index = $element.data("index");

                    return currentOption;
                } else {
                    return false;
                }
            } else {
                currentOption.value = $element.val();
                currentOption.index = $element.data("index");

                return currentOption;
            }
        });

        return Utils.compact(currentOptions);
    }

    _getVariantFromOptions() {
        const selectedValues = this._getCurrentOptions();
        const variants = this.product.variants;

        for (const variant of variants) {
            let satisfied = true;

            for (const option of selectedValues) {
                if (satisfied) {
                    satisfied = option.value === variant[option.index];
                }
            }

            if (satisfied) {
                return variant;
            }
        }

        return null;
    }

    _onSelectChange() {
        const variant = this._getVariantFromOptions();
        this.$container.trigger({
            type: "variantChange",
            variant: variant,
        });

        if (!variant) {
            return;
        }

        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this.currentVariant = variant;

        if (this.enableHistoryState) {
            this._updateHistoryState(variant);
        }
    }

    _updateImages(variant) {
        const variantImage = variant.featured_image || {};
        const currentVariantImage = this.currentVariant.featured_image || {};
        if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
            return;
        }

        this.$container.trigger({
            type: "variantImageChange",
            variant: variant,
        });
    }

    _updatePrice(variant) {
        if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
            return;
        }

        this.$container.trigger({
            type: "variantPriceChange",
            variant: variant,
        });
    }

    _updateHistoryState(variant) {
        if (!history.replaceState || !variant) {
            return;
        }

        const params = window.location.search;
        const paramsWithoutVariant = params.split("&").slice(1).join("&");

        const newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?variant=${variant.id}&${paramsWithoutVariant}`;
        window.history.replaceState({ path: newurl }, "", newurl);
    }

    _updateMasterSelect(variant) {
        $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
}

class Swatches {
    constructor(color) {
        this.init();

        const query = `.colors__item--${color.toLowerCase()}`;
        const obj = {
            currentTarget: document.querySelector(query),
        };
        this.updateSwatches(obj);
    }

    init() {
        // Event delegation to handle swatch clicks
        $("body").on("click", ".colors__item", (e) => {
            e.preventDefault();
            this.updateSwatches(e);
        });
    }

    updateSwatches(e) {
        const $swatch = $(e.currentTarget).find(".color__swatch");
        const color = $swatch.attr("data-color");
        const listItem = $swatch.closest(".list__item--color");
        const listItemSelect = listItem.find(".color__select");
        // Update UI based on selected color
        listItem.find("label span").text(color);
        $(".color__colors a").removeClass("active");
        if ($swatch.hasClass("active")) {
            $swatch.removeClass("active");
        } else {
            document.querySelectorAll(".color_swatch .colors__item").forEach((color) => color.querySelector(".color__swatch").classList.remove("active"));
            $swatch.addClass("active");
        }
        listItemSelect.val(color).trigger("change");
    }

    destroy() {
        // Remove the click event handler when no longer needed
        $("body").off("click", ".colors__item");
    }
}

class Carousels {
    constructor() {
        this.init();
        window.addEventListener("resize", this.resize);
    }

    init() {
        if ($(".images__list").length) {
            $(".images__list").each(function () {
                if ($(this).closest(".product").parent().is(":visible")) {
                    if ($(this).closest(".product").hasClass("product--vertical") && mqDesktop.matches) {
                        $(this).slick({
                            infinite: true,
                            slidesToShow: 6,
                            slidesToScroll: 1,
                            arrows: true,
                            verticalSwiping: true,
                            vertical: true,
                            nextArrow: `<button type="button" class="slick-next">^</button>`,
                            prevArrow: `<button type="button" class="slick-prev">^</button>`,
                        });
                    } else {
                        $(this).slick({
                            infinite: true,
                            slidesToShow: 4,
                            slidesToScroll: 4,
                            arrows: true,
                            centerPadding: "0",
                            nextArrow: `<button type="button" class="slick-next">></button>`,
                            prevArrow: `<button type="button" class="slick-prev"><</button>`,
                            touchMove: false,
                        });
                    }
                }
            });

            $(".product__images .list__item a").on("click", function (e) {
                e.preventDefault();
                const src = $(this).attr("data-image");
                const srcFancybox = $(this).attr("data-image-fancybox");
                $(".product__images .images__featured").attr("src", src);
                $(".product__images .product-gallery__link").attr("href", srcFancybox);
            });
            $(".product__images-slider").slick("setPosition");
        }

        $(".product__images-slider").slick({
            dots: true,
            infinite: false,
        });

        $(".product__images-slider").each(function () {
            let $this = $(this);
            let sliderItems = $(".product-gallery__link", $this);
            sliderItems.slice(sliderItems.length / 2 + 1).attr("data-fancybox", "");
            $(".video-container").removeAttr("data-fancybox");
        });

        this.resize();

        $(".product__images > .product-gallery__link").css("display", "none");
    }

    resize() {
        // only show slider if we're on the bundle builder page, or on a tablet.
        if (document.getElementById("benji-bundle-2") || window.matchMedia("(max-width: 768px)").matches) {
            $(`.product__images-slider`).css("display", "block");
            $(`.product__images-grid`).css("display", "none");
        } else {
            $(`.product__images-grid`).css("display", "flex");
            $(`.product__images-slider`).css("display", "none");
        }
    }

    destroy() {
        $(".images__list").each(function () {
            $(this).slick("unslick");
        });

        $(".product__images .list__item a").off("click");
    }
}

class SleepCalculator {
    constructor() {
        this.ageRangeInput = $('.sleep__item--age input[type="range"]');
        this.hoursRangeInput = $('.sleep__item--hours input[type="range"]');
        this.totalSpan = $(".sleep__total span");
        this.ratioSpan = $(".sleep__ratio span");

        this.init();
    }

    init() {
        this.ageRangeInput.on("input change", () => this.calculate());
        this.hoursRangeInput.on("input change", () => this.calculate());
        this.ageRangeInput.trigger("change");
    }

    calculate() {
        const age = Number(this.ageRangeInput.val());
        const hours = Number(this.hoursRangeInput.val());
        const days = Number(age * 365);
        let hoursSlept = Number(days * hours);

        const allHours = days * 24;
        const percent = Math.round((hoursSlept / allHours) * 100);

        hoursSlept = hoursSlept.toLocaleString();

        $(".sleep__item--age span.item__title").text(age);
        $(".sleep__item--hours span.item__title").text(hours);
        this.totalSpan.text(hoursSlept);
        this.ratioSpan.text(percent);
    }
}

benji.carousels = new Carousels();
benji.sections = new Sections();
benji.sections.register("product", Product);

benji.customerLogin = new CustomerLogin();
if (window.location.pathname.includes("about")) {
    benji.sleepCalculator = new SleepCalculator();
}
